import * as React from 'react';
import Container from '@mui/material/Container';
import Copyright from '@/components/Copyright';
import { Notification } from '@/components/Notification';
import { AppContext } from '@my-helpers/common';
import { useContext } from 'react';
import { Registration } from '@/components/registration';
import { useNavigate } from 'react-router-dom';

export default function SignUp() {
	const app = useContext(AppContext);
	if (!app) {
		throw new Error('useAppContext must be used within an AppProvider');
	}
	const {isLoading, error, isDarkMode} = app.view;
	const {signUp, clearError} = app.command;
	const navigate = useNavigate();
	const [confirmed, setConfirmed] = React.useState<boolean>(false);

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		const data = new FormData(event.currentTarget);
		const firstName = data.get('firstName') as string;
		const lastName = data.get('lastName') as string;
		const email = data.get('email') as string;
		const password = data.get('password') as string;

		await signUp(firstName, lastName, password, email);
		navigate('/verify');
	};

	return (
			<Container 
				component="main" 
				maxWidth={!confirmed ? "md" : "xs"}>
				<Registration
					handleSubmit={handleSubmit}
					confirmed={confirmed}
					setConfirmed={setConfirmed}
				/>
				<Notification
					isLoading={isLoading}
					clearError={clearError}
					error={error}
					delay={300}
					autoHideDuration={1200}
				/>
				<Copyright sx={{ mt: 5 }} />
			</Container>
	);
}
